import { createFileRoute } from '@tanstack/react-router'
import { PackStudioPage } from '@/features/pack-studio'

export const Route = createFileRoute('/_authenticated/automation/pack-studio')({
  component: PackStudioPage,
})
